import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ResourceSelect from "../../../../../components/Inputs/ResourceSelect";
import {
	renderSettingsResourceLabel,
	getSettingsResourceSearchFilters,
	getSettingsOrgResourceSearchFilters,
} from "../../../../../utils/helpers/settings";
import { useGroups } from "../../../../Settings/General/OrganisationLevelGroups/context";
import { useOrgSettingsResourceLabel } from "../../../../../utils/hooks/useOrgSettingsResourceLabel";

export const useHomeFilters = () => {
	const { t } = useTranslation();
	const { groups } = useGroups();
	const renderOrgLevelResourceLabel = useOrgSettingsResourceLabel();

	return useMemo(
		() => [
			{
				id: "locationHome",
				Header: t("locations-home"),
				canFilter: true,
				filter: "resource-select",
				Filter: (
					<ResourceSelect
						resourcePath="/locations?pagination=off"
						mode="multiple"
						renderLabel={renderSettingsResourceLabel}
						getSearchFilters={getSettingsResourceSearchFilters}
						hasSearch
					/>
				),
			},
			...groups.map((group) => ({
				id: `${group.level.replace("_", "")}Home`,
				Header: renderSettingsResourceLabel(group),
				canFilter: true,
				filter: "resource-select",
				Filter: (
					<ResourceSelect
						mode="multiple"
						resourcePath={`/${group?.id}/org-levels`}
						renderLabel={renderOrgLevelResourceLabel}
						valuePropName="id"
						getSearchFilters={getSettingsOrgResourceSearchFilters}
						hasSearch
					/>
				),
			})),
			{
				id: "groupingHome",
				Header: t("groupings-home"),
				canFilter: true,
				filter: "resource-select",
				Filter: (
					<ResourceSelect
						resourcePath="/grouping?pagination=off&excludedResources=pay-code"
						mode="multiple"
						renderLabel={renderSettingsResourceLabel}
						getSearchFilters={getSettingsResourceSearchFilters}
						hasSearch
					/>
				),
			},
		],
		[groups, renderOrgLevelResourceLabel, t],
	);
};
